// extracted by mini-css-extract-plugin
export default {"root":"Camera_root__5WsNt","img":"Camera_img__erhug","video":"Camera_video__79KhA","imageMirror":"Camera_imageMirror__2SOwF","invis":"Camera_invis__33V6j"};